import { render } from "./RepresentativesTable.vue?vue&type=template&id=db4722d4"
import script from "./RepresentativesTable.vue?vue&type=script&lang=ts"
export * from "./RepresentativesTable.vue?vue&type=script&lang=ts"
script.render = render

export default script